<ng-container
    *ngIf="control()?.invalid && (control()?.dirty || control()?.touched)"
>
    <span class="validation-message" *ngFor="let errorKey of errorKeys">
        {{ getMessage(errorKey) }}
    </span>
</ng-container>
